import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=4c3beceb&scoped=true"
import script from "./handle.vue?vue&type=script&lang=js"
export * from "./handle.vue?vue&type=script&lang=js"
import style0 from "./handle.vue?vue&type=style&index=0&id=4c3beceb&prod&lang=scss&scoped=true"
import style1 from "./handle.vue?vue&type=style&index=1&id=4c3beceb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3beceb",
  null
  
)

export default component.exports